import React from "react";
import PropTypes from "prop-types";
import { useTeamByAssigneeTaskNavigation } from "~/components/Hooks";
import { TaskSheet } from "./TaskSheet";

export const TeamsByAssigneeNavigation = React.forwardRef(({ taskId, userId, ...props }, ref) => {
  const [prev, next] = useTeamByAssigneeTaskNavigation(taskId, userId);
  return (
    <TaskSheet
      ref={ref}
      taskId={taskId}
      prev={prev}
      next={next}
      {...props}
    />
  );
});

TeamsByAssigneeNavigation.propTypes = {
  taskId: PropTypes.number,
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
};

TeamsByAssigneeNavigation.displayName = "TeamsByAssigneeNavigation";
